(function ($, app, _estimateShippingPostcode) {
    var _eventHandler = _.extend({}, Backbone.Events);
    var _imageSize = 200;
    var _isMobile = false;
    var $ready = new $.Deferred();
    
    var RemoveFromCartPixel = RemoveFromCartPixelModule();

    $(function () {
        $ready.resolve();
    });

    var _getDeliveryDetails = function () {
        return _estimateShippingPostcode.getDeliveryDetails();
    }

    var getOrderDetails = function (wait) {
        var _deliveryDetails = _getDeliveryDetails();
        if (window.__isAuthorized__) {
            return api.getCurrentOrder({ imageSize: _imageSize, deliveryDetails: _deliveryDetails, pickupPoint: ''}, { wait: wait === true, serverErrorHandleOption: api.RedirectionOptionsEnum.PopupMessage });
        } else {
            return api.getPublicCurrentOrder({ imageSize: _imageSize, deliveryDetails: _deliveryDetails, pickupPoint: '' }, { wait: wait === true,  serverErrorHandleOption: api.RedirectionOptionsEnum.PopupMessage });
        }
    };

    var getApiMethod = function (privite, public) {
        return _.bind((IsAuthorized() ? privite : public), api);
    };

    var createTransaction = function () {

        window.__isAuthorized__ = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');

        var postdata = $('[id$=hidAfterpay]').val();
        if (postdata) {
            postdata = JSON.parse(postdata);
            if (postdata.status === 'SUCCESS') {
                var afterpayResult;
                var afterpayDef = new $.Deferred();
                if (window.__isAuthorized__) {
                    afterpayResult = api.afterPayCreatePayment({ token: postdata.token }, { wait: true, hideErrors: true });
                } else {
                    afterpayResult = api.afterPayCreatePublicPayment({ token: postdata.token }, { wait: true, hideErrors: true });
                }
                afterpayResult.done(afterpayDef.resolve)
                    .fail(function (data) {
                        if (data && data.Result === false && data.Message) {
                            kos.dialog.error({ message: data.Message });
                        }
                        afterpayDef.resolve(data);
                    });
                return afterpayDef.promise();
            }
        }

        var postdata = $('[id$=hidOpenpay]').val();
        if (postdata) {
            postdata = JSON.parse(postdata);
            if (postdata.status === 'LODGED' || postdata.status === 'FAILED') {
                var openpayResult;
                var openpayDef = new $.Deferred();
                if (window.__isAuthorized__) {
                    openpayResult = api.openpayCapturePayment({ planId: postdata.planId, orderId: postdata.orderId, status: postdata.status }, { wait: true, hideErrors: true });
                } else {
                    openpayResult = api.openpayCapturePublicPayment({ planId: postdata.planId, user: postdata.user, orderId: postdata.orderId, status: postdata.status }, { wait: true, hideErrors: true });
                }
                openpayResult.done(openpayDef.resolve)
                    .fail(function (data) {
                        if (data && data.Result === false && data.Message) {
                            kos.dialog.error({ message: data.Message });
                        }
                        openpayDef.resolve(data);
                    });
                return openpayDef.promise();
            }
        }


        postdata = $('[id$=hidIPay]').val();
        if (postdata && window.__isAuthorized__) {
            return api.paymentIPay({ postData: JSON.parse(postdata) }, { wait: true/*, hideErrors: true*/ });
        }

        postdata = $('[id$=hidHumm]').val();
        if (postdata) {
            if (window.__isAuthorized__) {
                return api.createHummOrder(JSON.parse(postdata),
                    { wait: true });
            } else {
                return api.createPublicHummOrder(JSON.parse(postdata),
                    { wait: true });
            }
        }

        postdata = $('[id$=hidZipPayAU]').val();
        if (postdata && window.__isAuthorized__) {
            return api.createZipCharge({ data: JSON.parse(postdata) }, { wait: true/*, hideErrors: true*/ });
        }

        postdata = $('[id$=hidZipPayNZ]').val();
        if (postdata && window.__isAuthorized__) {
            return api.createZipCharge({ data: JSON.parse(postdata) }, { wait: true/*, hideErrors: true*/ });
        }

        postdata = $('[id$=hidLPay]').val();
        if (postdata) {
            window.app && app.event && app.event.lPayCreateCharge();
            if (window.__isAuthorized__) {
                return api.confirmLPayTransaction(JSON.parse(postdata),
                    { wait: true });
            } else {
                return api.confirmPublicLPayTransaction(JSON.parse(postdata),
                    { wait: true });
            }
        }


        return new $.Deferred().resolve({Result: false}).promise();
    }

    var _parseAvailablePaymentMethods = function (data) {
        var settings = CheckoutSettings.getBasketSettings();
        if (!settings.StripeEnabledWithOurPay && data.Value.MyPayDetails && data.Value.MyPayDetails.Enabled) {
            data.Value.AvailablePaymentOptions = data.Value.AvailablePaymentOptions.filter(function (m) {
                return !m.Name.match(/stripe/gi);
            });
        }
        return data;
    };

    var _popupOk = function (message) {
        if (message) {
            var dialog = kos.dialog.popup({
                cls: 'test-surcharge-notification',
                closeBtn: true,
                message: message,
                buttons: [
                    { 'role': 'okButton', text: 'OK', 'class': 'MiddleButton custom-dialog-go-to-basket' }
                ]
            });
            dialog.$('.notifier-message').css('padding-bottom', '10px');
            dialog.$('@okButton').on('click', dialog.destroy);
        }
    }

    var _popup = function (message) {
        if (message) {
            kos.dialog.popup({
                cls: 'test-surcharge-notification',
                closeBtn: true,
                message: message
            });
        }
    }

    var checkout = function () {

        this.transactionXhr = createTransaction();
        this.pixel = new RemoveFromCartPixel();
        
        var tryCreateTransactionXhr = new $.Deferred();

        $.when(this.transactionXhr, app.settings.ready()).then(function(data) {
            if (!data.Result || (data.Value && !data.Value.isPaid)) {
                tryCreateTransactionXhr.resolve();
            } else {
                tryCreateTransactionXhr.reject({ stopPropagation: true });
            }
        });

        var getOrderDetailsXhr = tryCreateTransactionXhr.promise().then(getOrderDetails);

        this.orderXhr = $.when(getOrderDetailsXhr.then($.proxy(this._parseBasketData, this)), $ready.promise());


        this.paymentXhr = tryCreateTransactionXhr
            
            .then(function() {
                if (window.__isAuthorized__) {
                    return api.getBraintreeUserPaymentMethods();
                }
                return new $.Deferred().reject().promise();
            })
            .then($.proxy(this._parseData, this))
            .then($.proxy(function(data) {
                /* Chose first Payment Method as default if LastPaidToken is null */
                var hasPaymentMethods = !!(data && data.PaymentMethods && data.PaymentMethods.length || 0);
                if (hasPaymentMethods && !data.LastPaidToken) {
                    data.LastPaidToken = data.PaymentMethods[0].Token;
                }
                if (hasPaymentMethods) {
                    /* Wrap */
                    return this.orderXhr.then(function(order) {
                        var availablePaymentOptions = order.AvailablePaymentOptions;

                        /* Wrapped code */
                        _.each(data.PaymentMethods,
                            function(method) {
                                method.PaymentType = PaymentTypes.get(method.PaymentType);
                            });
                        /* Wrapped code */

                        data.PaymentMethods = _.filter(data.PaymentMethods,
                            function(method) {
                                return method.ProviderType !== 'stripe' ||
                                    !!_.where(availablePaymentOptions, { Name: 'Stripe' }).length;
                            });

                        var hasPaymentMethods = !!data.PaymentMethods.length;
                        if (hasPaymentMethods && !_.where(data.PaymentMethods, { Token: data.LastPaidToken } ).length ) {
                            data.LastPaidToken = data.PaymentMethods[0].Token;
                        }

                        return data;
                    });
                    /* Wrap */
                } else {
                    return data;
                }
            }, this))
            .fail(function(result) {
                if (result && (result.stopPropagation || result.IsAuthenticated)) return;

                $(function() {
                    if (!window.__useGuestCheckout__ && !app.settings.get('UseEmbeddedLoginForm')) {
                        landingForm.showPopup({ closeBtn: true }).done(function () {
                            location.reload();
                        }).fail(function () {
                            var redirectUrl = globalUrls.returnUrl;

                            if (document.referrer) {
                                var ref = document.referrer.match(/:\/\/(.[^/]+)/)[1];

                                if (ref === location.hostname) {
                                    redirectUrl = document.referrer;
                                }
                            }

                            window.location = redirectUrl;
                        });
                    }
                });


            })
            .always(function() {
                if (window.__isAuthorized__) {
                    api.checkoutViewEvent();
                } else {
                    api.checkoutPublicViewEvent();
                }
            });
        
        this._update = $.proxy(function (data) {
            _eventHandler.trigger('update', this._parseBasketData(data));
        }, this);
    };

    checkout.prototype = {
        _parseBasketData: function (data) {
            var ourpay = ourpay_data_mapper(data.Value);
            data.Value.MyPayDetails = ourpay.MyPayDetails;

            if (data.Value && data.Value.Shipments && !data.Value.Shipments.length) {
                data.Value.UseLocationDeliveryPriceSettings = false;
            }

            data = _parseAvailablePaymentMethods(data);

            if ((data.Value.Shipments || []).filter(function (s) { return s.ShippingAvailability === false }).length) {
                window.app && app.event && app.event.notAvailableDeliverToLocation && app.event.notAvailableDeliverToLocation();
            }

            return data.Value;
        },

        _parseData: function (data) {
            return data.Value;
        },
        onUpdate: function (cb) {
            if ($.isFunction(cb)) {
                _eventHandler.on('update', cb);
            }
        },
        onUpdatePayment: function(cb) {
            if ($.isFunction(cb)) {
                _eventHandler.on('update', cb);
            }
        },
        onUpdateToken: function(cb) {
            if ($.isFunction(cb)) {
                _eventHandler.on('update', cb);
            }
        },
        update_checkout: function(wait) {
            return getOrderDetails(wait).done(this._update);
        },

        /* Items */
        payHumm: function () {
            var details = IsAuthorized() ? null : app.getCustomerData();
            var callback = location.origin + location.pathname;
            var _postdata = { 'data': details, 'callback': callback };
            return getApiMethod(api.createHummPaymentRequest, api.createPublicHummPaymentRequest)(_postdata);
        },

        /* Items */
        increaseItemQty: function (model) {
            var _postdata = {
                itemID: model.get('ID'),
                imageSize: _imageSize,
                deliveryDetails: _getDeliveryDetails(),
                pickupPoint: ''
            };
            return getApiMethod(api.increasePublicOrderItem, api.increasePublicOrderItem)
                (_postdata, { abortOnRetry: false }).done(this._update);
        },

        decreaseItemQty: function (model) {
            var _postdata = {
                itemID: model.get('ID'),
                imageSize: _imageSize,
                deliveryDetails: _getDeliveryDetails(),
                pickupPoint: ''
            };
            return getApiMethod(api.decreasePublicOrderItem, api.decreasePublicOrderItem)
                (_postdata, { abortOnRetry: false }).done(this._update);
        },

        deleteItemQty: function (model) {
            var _postdata = {
                itemID: model.get('ID'),
                deliveryDetails: _getDeliveryDetails()
            };
            
            this.pixel.remove(app, model);
            
            return getApiMethod(api.deletePublicOrderItem, api.deletePublicOrderItem)
                (_postdata, { abortOnRetry: false }).done(this._update);
        },

        /* Delivery */
        switchBasketMode: function (mode) {
            return api.switchBasketMode(mode).done(this._update);
        },
        setUserGiftAddress: function (address) {
            return api.setUserGiftAddress(address).done(this._update);
        },
        setUserPublicGiftAddress: function (address, data) {
            return api.setUserPublicGiftAddress(address, data).done(this._update);
        },
        setUserBillingAddress: function (address) {
            return api.setUserBillingAddress(address).done(this._update);
        },
        setUserPublicBillingAddress: function (address) {
            return api.setPublicBillingAddress(address).done(this._update);
        },
        setUserGiftAndBillingAddress: function (giftAddress, billingAddress) {
            return api.setUserGiftAndBillingAddress({ address: giftAddress, billingAddress: billingAddress }).done(this._update);
        },
        setPublicGiftAndBillingAddress: function (giftAddress, billingAddress, data) {
            return api.setPublicGiftAndBillingAddress({ address: giftAddress, billingAddress: billingAddress, data: data }).done(this._update);
        },

        setAuthToLeave: function (model) {
            return getApiMethod(api.setAuthToLeave, api.setPublicAuthToLeave)({
                authToLeave: model.get('AuthToLeave'),
                authComment: model.get('AuthComment'),
                deliveryAddressID: model.get('ID')
            });
        },

        setDeliveryOption: function (deliveryOption) {
            var method = getApiMethod(api.setDeliveryOption, api.setPublicDeliveryOption);
            return method({
                optionParameters: deliveryOption,
                imageSize: _imageSize,
                deliveryDetails: _getDeliveryDetails(),
            }, { wait: true, delay: 1000 }).done(this._update);
        },

        saveBillingAddress: function (address) {
            return api.saveBillingAddress(address);
        },

        getUserAddresses: function () {
            if (window.__isAuthorized__) {
                return api.getUserAddresses();
            } else {
                return new $.Deferred().resolve(null).promise();
            }
        },

        applyDeliveryAddress: function (model) {
            api.applyDeliveryAddress(model.get('ID'), _imageSize).done(this._update);
        },

        applyGiftDeliveryAddress: function (id) {
            return api.applyDeliveryAddress(id, _imageSize).done(this._update);
        },

        setUserDeliveryAddress: function (address) {
            return api.setUserDeliveryAddress(address)
                .then(function(data) {
                    if (data.Result || data.Value) {
                        return api.applyDeliveryAddress(data.Value, _imageSize);
                    } else {
                        return new $.Deferred().reject();
                    }
                }).done(this._update);
        },

        setPublicDeliveryAddress: function (address, data) {
            return api.setPublicDeliveryAddress(address, data)
                .done(this._update);
        },

        getPickupPointsByPostcode: function (postcode) {
            return api.getPickupPointsByPostcode(postcode, { hideErrors: true });
        },

        getPickupPointsByCoordinates: function (postcode) {
            return api.getPickupPointsByCoordinates(postcode, { hideErrors: true });
        },

        getDeliveryServicePackageDetails: function() {
            if (window.__isAuthorized__ || window.__useGuestCheckout__) {
                return api.getPublicDeliveryServicePackageDetails({ hideErrors: true })
                    .then(function(data) {
                        return data.Value;
                    });
            } else {
                return new $.Deferred().reject().promise();
            }
        },

        /* Vouchers */
        applyVoucher: function (model) {
            var deliveryDetails = _getDeliveryDetails();
            return api.applyVoucher({
                'voucherID': model.id,
                'imageSize': _imageSize,
                'deliveryDetails': deliveryDetails
            }).done(this._update);
        },

        addAndApplyVoucherByKey: function (value) {
            var deliveryDetails = _getDeliveryDetails();
            var method = getApiMethod(api.addAndApplyVoucherByKey, api.addAndApplyPublicVoucherByKey);
            return method({
                'key': value,
                'imageSize': _imageSize,
                'deliveryDetails': deliveryDetails
            }).done(this._update);
        },

        removeVoucher: function (model) {
            var deliveryDetails = _getDeliveryDetails();
            return api.removeVoucher({
                'voucherID': model.id,
                'imageSize': _imageSize,
                'deliveryDetails': deliveryDetails
            }).done(this._update);
        },

        removeVoucherByKey: function (value) {
            var deliveryDetails = _getDeliveryDetails();
            return api.removeVoucherByKey({
                'key': value,
                'imageSize': _imageSize,
                'deliveryDetails': deliveryDetails
            }).done(this._update);
        },

        /* Payments IPay */

        redirectToIPay: function() {
            return api.redirectToIPay(window.location.href)
                .done(function(data) {
                    $(data.Value).appendTo('body').submit();
                });
        },

        checkTransactionParams: function (cb) {
            this.transactionXhr.done(function(data) {
                if (data.Result) {
                    cb(data);
                }
            });
        },

        /* Payments Masterpass*/

        masterPassPostTransaction: function(data) {
            return api.masterPassPostTransaction({
                    OAuthToken: data.oauth_token,
                    OAuthVerifier: data.oauth_verifier,
                    CheckoutResourceUrl: data.checkout_resource_url,
                    PairingToken: data.pairing_token,
                    PairingVerifier: data.pairing_verifier,
                    IsMobile: _isMobile
                }, { wait: true });
        },

        masterPassPayment: function () {
            return api.masterPassPayment({ wait: true/*, hideErrors: true*/ });
        },

        normalizePhoneAndSendCode: function (phoneNumber) {
            if (!IsAuthorized()) {
                var details = app.getCustomerData();
                if (details.isValid) {
                    return api.publicNormalizePhoneAndSendCode(phoneNumber, details, { wait: true });
                }
            } else {
                return api.normalizePhoneAndSendCode(phoneNumber, { preventDoubleRequests: true });
            }
        },

        verificationCodeConfirm: function (phoneNumber, code) {
            if (!IsAuthorized()) {
                var details = app.getCustomerData();
                if (details.isValid) {
                    return api.verificationPublicCodeConfirm(phoneNumber, code, details, { preventDoubleRequests: true });
                }
            } else {
                return api.verificationCodeConfirm(phoneNumber, code, { preventDoubleRequests: true });
            }
        },

        getDeliveryPrice: function (postcode) {
            return api.getDeliveryPrice(postcode);
        }
    };

    app.checkout = new checkout();
})(jQuery, app, EstimateShippingPostcode);